import { Component, OnInit, Input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../../shared/providers/common.service';
import { PropertyListingService } from '../../../../shared/providers/property-listing.service';
import { NewsTickerDetailsModel } from '../../../../shared/models/NewsTickerDetailsModel';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
//import * as Highcharts from 'highcharts';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../../../shared/providers/toast.service';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';

interface IStockInfo {
  brand: string;
  currentPrice: string;
  regularMarketChangePercent: string;
  postMarketChangePercent: string;
  symbol: string;
}
@Component({
  selector: 'app-stock-info',
  templateUrl: './stock-info.component.html',
  styleUrls: ['./stock-info.component.css']
})
export class StockInfoComponent implements OnInit {

  constructor(private commonService: CommonService, public authService: AuthenticationService, private Toast: ToastService, private Loader: LoaderService, protected activatedRoute: ActivatedRoute, private modalService: BsModalService, public router: Router, private propertyListing: PropertyListingService) { }
  @Input() tickerSymbol = [];
  symbol = "";
  stockInfo: IStockInfo[] = [];
  stockInformation = {} as any;
  @Input() isFromDashboard = true;
  showMarketValue = false;
  @Input() fromSummaryPage = false;
  @Input() SourcePage: string = '';
  @Output() tickerChanges = new EventEmitter();
  @Output() newTickerAdded = new EventEmitter();
  newsDetail = {} as NewsTickerDetailsModel;
  slideConfig = {
    "slidesToShow": 2, "slidesToScroll": 2, "speed": 800, "centerMode": false, "dots": false, "variableWidth": true, "autoplay": false, "autoplaySpeed": 2000, "infinite": false, "arrows": true
  };
  afterChange(e) {

  }

  @Input() sellerId = 0;
  @Input() prevPage: string = null;
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params["ticker"] != null) {
        this.symbol = params["ticker"];
      }

      if (params["seller"] != null) {
        this.sellerId = params["seller"];
      }
    });
    if (this.tickerSymbol.length > 0) {
      this.symbol = this.tickerSymbol[0];
      this.getadata();
    }
    else {
      this.propertyListing.GetDefaultTickers(this.sellerId).subscribe(response => {
        this.tickerSymbol = response;
        if (this.symbol == "" && response.length > 0) {
          this.symbol = response[0]["Symbol"];
        }
        this.getadata();
      });
    }
  }
  getadata() {
    this.tickerSymbol.forEach(item => {
      if (this.stockInfo == undefined || this.stockInfo.filter(i => i.symbol == item["Symbol"]).length == 0) {
        try {
          this.commonService.GetNewsTickerDetails(item["Symbol"], 6101).subscribe(response => {
            if (!response.IsLatestAvailable) {
              this.propertyListing.GetStockValues(item["Symbol"]).subscribe(res => {
                if (res != null) {
                  this.stockInformation = res;
                  let stockResponse = this.stockInformation != null && this.stockInformation != undefined ?
                    this.stockInformation.quoteResponse.result[0] : null;
                  if (stockResponse != null && stockResponse != undefined) {
                    const regularMarketPriceFmtPercentage = this.formatAsPercentage(stockResponse["regularMarketPrice"]);
                    const regularMarketChangePercentFmtPercentage = this.formatAsPercentage(stockResponse["regularMarketChangePercent"] );
                    const postMarketChangePercentFmtPercentage = this.formatAsPercentage(stockResponse["postMarketChangePercent"]);
                    const stock =
                    {
                      brand: stockResponse["longName"] ? stockResponse["longName"] : stockResponse["shortName"],
                      currentPrice: stockResponse["regularMarketPrice"],
                      regularMarketChangePercent: regularMarketChangePercentFmtPercentage != undefined ? regularMarketChangePercentFmtPercentage : null,
                      postMarketChangePercent: postMarketChangePercentFmtPercentage != undefined ? postMarketChangePercentFmtPercentage : null,
                      symbol: item["Symbol"],
                    }
                    this.stockInfo.push(stock);

                    this.showMarketValue = true;
                    this.newsDetail.DataJson = JSON.stringify(res);
                    this.newsDetail.Ticker = item["Symbol"];
                    this.newsDetail.TypeId = 6101;
                    this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(result => {
                    });

                    this.loadChart(stock);
                  }

                }
              });
            }
            else {
              this.stockInformation = JSON.parse(response.DataJson);
              let stockResponse = this.stockInformation != null && this.stockInformation != undefined ?
                this.stockInformation.quoteResponse.result[0] : null;
              if (stockResponse != null && stockResponse != undefined) {
                const regularMarketChangePercentFmtPercentage = this.formatAsPercentage(stockResponse["regularMarketChangePercent"]);
                const postMarketChangePercentFmtPercentage = this.formatAsPercentage(stockResponse["postMarketChangePercent"]);
                const stock =
                {
                  brand: stockResponse["longName"] ? stockResponse["longName"] : stockResponse["shortName"],
                  currentPrice: stockResponse["regularMarketPrice"],
                  regularMarketChangePercent: regularMarketChangePercentFmtPercentage != undefined ? regularMarketChangePercentFmtPercentage : null,
                  postMarketChangePercent: postMarketChangePercentFmtPercentage != undefined ? postMarketChangePercentFmtPercentage : null,
                  symbol: item["Symbol"],
                }
                this.stockInfo.push(stock);
                //this.stockInfo = this.stockInfo.sort((a, b) => a["brand"] > b["brand"] ? 1 : a["brand"] === b["brand"] ? 0 : -1);
                this.showMarketValue = true;
                this.loadChart(stock);
              }
            }
          });
        }
        catch { }
      }
    });
  }

  formatAsPercentage(rawValue: number): string {
    if (rawValue != null && rawValue != undefined) {
      return `${rawValue.toFixed(2)}%`;
    }
  }
  getColorForStock(value: string) {
    if (value != undefined && value != null) {
      const stringValue = String(value);
      if (stringValue.includes('-')) {
        return '#f0605d'
      }
      else {
        return '#28A79B'
      }
    }
  }

  stockValueHigh(value: string) {
    if (value != undefined && value != null) {
      const stringValue = String(value);
      if (stringValue.includes('-')) {
        return false;
      }
      else {
        return true;
      }
    }
  }

  changeTicker(ticker) {
    var url = this.router.url.split("?");
    if (this.SourcePage != null && this.SourcePage != '') {
      this.prevPage = this.SourcePage;
    }
    if (url.length > 1) {
      if (this.authService.Admin() || this.authService.SuperAdmin()) {
        this.router.navigateByUrl("redirect?url=" + encodeURIComponent(url[0] + "?ticker=" + ticker + "&seller=" + this.sellerId + "&prevPage=" + this.prevPage), { skipLocationChange: true });
      }
      else {
        this.router.navigateByUrl("redirect?url=" + encodeURIComponent(url[0] + "?ticker=" + ticker), { skipLocationChange: true });
      }
    }
    else {
      if (this.authService.Admin() || this.authService.SuperAdmin()) {
        this.router.navigateByUrl("redirect?url=" + encodeURIComponent('/finance/financialsummary?ticker=' + ticker + "&seller=" + this.sellerId + "&prevPage=" + this.prevPage), { skipLocationChange: true });
      }
      else {
        this.router.navigateByUrl("redirect?url=" + encodeURIComponent('/finance/financialsummary?ticker=' + ticker + "&prevPage=" + this.prevPage), { skipLocationChange: true });
      }
    }
  }
  modalRefAddTicker: BsModalRef;
  openAddTicker(template: TemplateRef<any>, classes: any) {
    this.modalRefAddTicker = this.modalService.show(template, { class: classes });
  }
  loadChart(value) {
    let that = this;
    setTimeout(function () {

      //that.stockInfo.forEach(function (value) {
      that.commonService.GetNewsTickerDetails(value.symbol, 6100).subscribe(response => {

        if (response.IsLatestAvailable) {
          var data = JSON.parse(response.DataJson);
          that.plotChart(data, value.symbol, value.postMarketChangePercent)
        }
        else {
          that.propertyListing.GetTickerChart(value.symbol, '1d', '1mo').subscribe(response => {
            if (response["chart"].result != null && response["chart"].result[0].timestamp) {
              that.newsDetail.DataJson = JSON.stringify(response["chart"].result[0]);
              that.newsDetail.Ticker = value.symbol;
              that.newsDetail.TypeId = 6100;
              that.commonService.saveNewsTickerDetail(that.newsDetail).subscribe(response => {
              });
              that.plotChart(response["chart"].result[0], value.symbol, value.postMarketChangePercent)
            }
          });
        }
      });
      //})
    }, 3000);
  }
  plotChart(data, id, value) {
    let that = this;
    //Highcharts.chart({
    //    chart: {
    //        renderTo: id,
    //        //backgroundColor: 'rgb(183, 5, 32)', //back ground color
    //        margin: 0 //removes all margin
    //    },
    //    xAxis: {
    //        categories: data.timestamp,
    //        type: 'datetime',
    //        dateTimeLabelFormats: {
    //            day: '%b-%d-%Y'
    //        },
    //        //title: {
    //        //    enabled: false
    //        //},
    //        labels: {
    //            enabled: false
    //        },
    //    },
    //    yAxis: {
    //        min: 0,
    //        title: {
    //            text: ''
    //        },
    //        lineWidth: 0,
    //        gridLineWidth: 0,
    //        lineColor: 'transparent',
    //        minorTickLength: 0,
    //        tickLength: 0,
    //        labels: {
    //            enabled: false
    //        },
    //    },
    //    title: {
    //        text: ''
    //    },
    //    tooltip: {
    //        enabled: false
    //    },
    //    credits: {
    //        enabled: false
    //    },
    //    legend: {
    //        enabled: false
    //    },
    //    plotOptions: {
    //        column: {
    //            pointPadding: 0.2,
    //            borderWidth: 0
    //        }
    //    },
    //    series: [{
    //        type: 'area',
    //        color: that.getColorForStock(value),
    //        data: data.indicators.quote[0].close
    //    }]
    //});
  }
  loadData(ticker) {

    this.commonService.GetNewsTickerDetails(ticker, 6100).subscribe(response => {
      var data = JSON.parse(response.DataJson);
      if (data != null && data.timestamp) {
        var chart = data;
        return chart.timestamp;
      }
    });
  }

  selectedTickerId = 0;
  selectedTickerindex = 0;
  modalRefRemoveTicker: BsModalRef;
  openModalForDeleteTicker(template: TemplateRef<any>, classes: any, tickerSymbol) {
    let ticker = this.tickerSymbol.find(x => x["Symbol"] == tickerSymbol);
    this.selectedTickerId = ticker.Id;
    this.selectedTickerindex = this.tickerSymbol.findIndex(x => x["Symbol"] == tickerSymbol);
    this.modalRefRemoveTicker = this.modalService.show(template, { class: classes });
  }

  removeTicker() {
    this.Loader.display(true);
    this.propertyListing.RemoveTickers(this.selectedTickerId).subscribe(res => {
      if (res["IsSuccess"]) {
        this.Toast.addToast({ title: 'Success', msg: 'Ticker removed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        this.Loader.display(true);
        this.tickerSymbol.splice(this.selectedTickerindex, 1);
        this.stockInfo = [];
        this.getadata();
        this.tickerChanges.emit();
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Failed to remove tickers', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.modalRefRemoveTicker.hide();
      this.Loader.display(false);
    });
  }
  closeAddTickerModal() {
    this.showMarketValue = false;
    this.stockInfo = [];
    this.tickerSymbol = [];
    this.newTickerAdded.emit();
    ////this.getadata();
    ///this.tickerChanges.emit();
    this.ngOnInit();
  }
}
